export const GetSPStructure = async (spName) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const formData = new FormData();
        formData.append('spName', spName);

        const requestOptions = {
            method: 'POST',
            body: formData,
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };

        const response = await fetch(`${ApiURL}ExcelUpload/getspstructure`, requestOptions);

        const result = await response.json();
        if (!result.success) {
            return { success: false, data: [] };
        }

        return { success: true, data: result.data };
    } catch (error) {
        console.error("Error:", error);
        return { success: false, data: [] };
    }
};


export const ExecuteSPStructure = async (jsonBody) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(jsonBody)
        };

        const response = await fetch(`${ApiURL}ExcelUpload/Dynamic`, requestOptions);
        const responseData = await response.json();

        if (response.ok) {
            return { success: responseData.success, message: responseData.message };
        } else {
            return { success: false, message: responseData.message  };
        }
    } catch (error) {
        console.error("Error:", error);
        return { success: false, message: error };
    }
};


export const GetSPDropdown = async (usercode) => {
    try {
        const ApiURL = window.Links.ApiURL;
        const authToken = localStorage.getItem("authToken");

        const requestOptions = {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            }
        };

        const response = await fetch(`${ApiURL}ExcelUpload/getspNames/${usercode}/0`, requestOptions);

        const result = await response.json();
        if (!result.success) {
            return { success: false, data: [] };
        }

        return { success: true, data: result.data };
    } catch (error) {
        console.error("Error:", error);
        return { success: false, data: [] };
    }
};
